//$Id$

//ignorei18n_starts
/**
 * @file ui-util
 * @version 1.0.0
 * @notes Deprecated Functions displayFadeMsgError - Use UI.Utils.showError
 * displayFadeMsg, successMessage - Use UI.Utils.showSuccess
 * ChangeClass, changeElementClass - Use UI.Utils.addClass
 * ShowGenBlock, ForceShowGenInline, ShowGenInline, loadAjaxTab, ajaxLoading - This loading not used currently
 * failureMsg - Use UI.Utils.showError
 * ShowHideBlock, showHide, ShowHideBlockGeneral, ShowHideInline, showHideByClass, switchHide - Use toggleSwitchHide
 * showHideMultipleDiv - Use UI.Utils.show & UI.Utils.hide
 * Hide, dispNone, setShowHide, setHide - Use UI.Utils.hide
 * setRemoveClass,SwapDivClasses - replaceWithClass
 * dispBlock, setAsVisible, removeHide - UI.Utils.show
 * UI.Utils.loadHangingForm, UI.Utils.unloadHangingForm - Use zpPopup.loadSpare
 * UI.Utils.isNewEnterprisePortal
 * UI.Utils.isEmptyEditor
 * UI.Utils.scrolledToEnd
 * UI.Utils.loadExtnPop
 * UI.Utils.unloadExtnPop
 * UI.Utils.loadUnEscapeDOM
 * UI.Utils.formatDate
 * UI.Utils.saveDashTabOrder
 * UI.Utils.fadeOut
 * UI.Utils.getRandomColor
 * UI.Utils.animateNumber
 * UI.Utils.insertComma
 * UI.Utils.removeFrom
 * UI.Utils.isVisible
 * UI.Utils.toggle
 * UI.Utils.renderTemplate
 * UI.Utils.getTemplate
 * UI.Utils.appendTemplate
 * UI.Utils.getRandomColor
 * errorMessage
 * showHideAnother
 * Visible
 * Hidden
 * jqToJs.(any function)
 *  
 */

const UI = {};

/**
 * Wrapper function for document.getElementById
 * @param {string} id Id of the element to locate
 * @returns Returns matched HTML Element with specified Id
 */

function getDocObj(id) {
	return document.getElementById(id);
}

/**
 * Convert pixel to inches
 * @param {number} pixels Required. Pixel value needed to convert
 * @param {boolean} withdecimal Optional. Required with decimal value
 * @returns {number} Returns inches for the given pixel value
 */

function convertPixelToInches(pixels, withdecimal) {
	if (withdecimal) {
		return (pixels / 96).toFixed(2);
	}
	else {
		return parseInt((pixels / 96).toFixed(2));
	}
}

/**
 * To focus the html element with or without time delay
 * @param {string} focusId  Node Id 
 * @param {number} delayInMs Delay in Millisecond
 */
function setFocus(focusId, delayInMs) {
	var toFocus = document.getElementById(focusId);
	var textValue = toFocus.value;
	toFocus.value = "";
	toFocus.value = textValue;
	if (delayInMs) {
		setTimeout(() => toFocus.focus(), delayInMs);
	} else {
		toFocus.focus();
	}
}

/**
 * Create HTML Element with given attribues
 * @param {string} tagName Element tag name. Eg: 'input'
 * @param {object} attributes HTML Attributes with value. Eg: {'class':'show', value:''} 
 * @returns Returns HTML Element
 */
function createAndSetAttributes(tagName, attributes) {
	var element = document.createElement(tagName);
	return setDomAttributes(element, attributes);
}

/**
 * Add HTML Attributes to the given element 
 * @param element HMTL Element
 * @param {object} attributes HTML attributes with value. Eg: {'class':'show', value:''} 
 * @returns HTML Element
 */
function setDomAttributes(element, attributes) {
	if (attributes != undefined && typeof (attributes) === "object") {
		for (var key in attributes) {
			element.setAttribute(key, attributes[key]);
		}
	}
	return element;
}

/**
 * Create HTML Element with specified attributes
 * @param {string} nodeName Node name. Eg: div, span 
 * @param {string} nodeClass Class attribute value
 * @param {string} nodeText Node inner text
 * @param {object} customAttr Extra attributes in object format. Eg: {'disabled': true, 'value':''}
 * @returns HTML Element
 */
function createElem(nodeName, nodeClass, nodeText, customAttr) {
	let newElem = createAndSetAttributes(nodeName, customAttr ? customAttr : {});
	nodeClass && newElem.setAttribute("class", nodeClass);
	nodeText && newElem.setAttribute("data-tooltip", nodeText);
	nodeText && newElem.setAttribute("ellipsis", "true");
	nodeText && (newElem.innerText = nodeText);
	return newElem;
}

/**
 * Add one or more child element at the end of specified parent element.
 * @param parentElement Parent HTML element
 * @param childNodeList Nodes want to append
 */
function appendChildren(parentElement, childNodeList) {
	if (NodeList.prototype.isPrototypeOf(childNodeList) || HTMLCollection.prototype.isPrototypeOf(childNodeList)) {
		var lastLength = childNodeList.length;
		for (var j = 0; j < childNodeList.length; lastLength != childNodeList.length ? (lastLength = childNodeList.length) : j++) {
			parentElement.appendChild(childNodeList[j]);
		}
	} else {
		parentElement.appendChild(childNodeList);
	}
}

UI.ComponentState = {
	formSlide: false,
	filterPop: false,
	widgetContainer: false,
	inAppHelpContainer: false,
	midPop: false,
	defaultPop: false,
	defaultSparePop: false,
	attachmentPop: false,

	setState: function (key, isActive) {
		if (this.hasOwnProperty(key)) {
			this[key] = !!isActive;
		} else {
			console.warn(`State "${key}" does not exist in UI.ComponentState`);
		}
	},

	getState: function (key) {
		return this.hasOwnProperty(key) ? this[key] : undefined;
	},

	isVisible: function (key) {
		return this.hasOwnProperty(key) ? this[key] : undefined;
	}
};


UI.Utils = {
	isEmptyEditor: function (editorId) {
		let content = ''
		if (Utils.editorObj[editorId]) {
			let editorDocument = Utils.editorObj[editorId].doc
			content = (editorDocument.body) ? editorDocument.body.textContent : ''
		}
		return (content.trim() == '')
	},
	scrolledToEnd: function (parentId, elementId) {
		return ($L(parentId).scrollTop() >= $L(elementId).offset().top + $L(elementId).outerHeight() - $L(parentId).innerHeight())
	},

	/**
	 * To show and remove freeze screen
	 * @functionType function UI.Utils.freezeScreen
	 * @param {boolean} mode Optional. True will show freezeScreen, false will remove freezeScreen. Default true
	 */
	freezeScreen: function (mode = true) {
		var freezeScreenElement = document.getElementById("zpsOverlayFreeze");
		if (freezeScreenElement != null) {
			freezeScreenElement.style.display = "";
			if (mode) {
				freezeScreenElement.classList.remove("hide", "hideimp");
			} else {
				freezeScreenElement.classList.add("hide");
			}
		}
	},


	/**
	 * Render the HTML Content in form container
	 * @functionType function UI.Utils.loadForm
	 * @param {*} object HTML Content
	 * @param {*} callback Function to be called after form rendered
	 */
	loadForm: function (object, callback, options = {}) {
		let formElement = document.getElementById('zps-rightformslide')
		$L(formElement).empty()
		formElement.classList.add('show-main-form') 
		if(object instanceof DocumentFragment) {
			jqToJs.append(formElement, object)
		} else {
			jQuery(formElement).html(object)
		}
		// for (let i = 0; i < object.length; i++) {
		// 	formElement.appendChild(object[i]);
		// }
		UI.Utils.freezeScreen(true)
		UI.ComponentState.setState('formSlide' , true);
		window.FocusUtil?.focusOnFirstElement(document.getElementById("zpsSlideItems"));
		findSticky(".slideFormBottombtn");

		// Handle criteria-builder mode
		if (options?.source === 'criteria-builder') {
			formElement.classList.add('criteria-mode');

			// Bind unload cleanup
			formElement.dataset.criteriaModeActive = 'true'; // flag to detect later
		}

		if (callback) {
			callback()
		}
	},

	/**
	 * Removes HTML Content from Form Container
	 * @functionType function UI.Utils.unloadForm
	 * @param {*} callback Function to be called after form removed from HTML DOM
	 */
	unloadForm: function (callback) {
		let formElement = document.getElementById('zps-rightformslide')
		formElement.classList.remove('show-main-form')

		// Cleanup criteria-builder mode if active
		if (formElement.dataset.criteriaModeActive === 'true') {
			formElement.classList.remove('criteria-mode');
			delete formElement.dataset.criteriaModeActive;
		}

		$L(formElement).empty()
		$L('.select2-drop-active').is(":visible") ? jqToJs.remove('.select2-drop-active') : void (0); 
		let visibleSlideElement = document.querySelectorAll('.zps-inapphelp-container.show-inapp-slide').length 
		UI.ComponentState.setState('formSlide' , false);
		if (visibleSlideElement < 1) {
			UI.Utils.freezeScreen(false)
		}
		if (callback) {
			callback()
		}
	},

	/**
	 * Render the HTML Content in Inapp help container
	 * @functionType function UI.Utils.loadInappHelp
	 * @param {*} helpparam
	 * @param {*} moduleData Object with help slider title 
	 * @param {*} callback Function to be called after rendered
	 */
	loadInappHelp: function (helpparam, moduleData, callback) {
		let helpElement = document.getElementById('zps-inapphelpcontent');
		let helpElementHeader = createAndSetAttributes('div', { 'class': 'inapphelp-header' });
		let helpElementHeaderText = createAndSetAttributes('span', { 'class': 'inapp-title' });
		let helpElementClose = createAndSetAttributes('i', { 'class': 'zoho-close' });
		helpElementClose.addEventListener('click', Function("UI.Utils.unloadInappHelp();"));
		let helpElementData = createAndSetAttributes('div', { 'class': 'inapphelp-data-container' });

		helpElementHeaderText.textContent = (moduleData && moduleData.title) ? moduleData.title : getI18nValue('zp.general.help');

		helpElementHeader.appendChild(helpElementHeaderText);
		helpElementHeader.appendChild(helpElementClose);
		helpElement.appendChild(helpElementHeader);
		helpElement.appendChild(helpElementData);
		let helpData = helpTemplates.getTemplate(helpparam, moduleData);
		ZCTemplates.removeCacheData(helpElementData);
		ZCTemplates.renderView(helpData, helpElementData);
		helpElement.classList.add('show-inapp-slide'); 
		UI.ComponentState.setState('inAppHelpContainer' , true);
		window.FocusUtil?.focusOnFirstElement(document.getElementById("zpsSlideItems"));

		UI.Utils.freezeScreen(true)
		if (callback) {
			callback()
		}
	},

	/**
	 * Removes HTML Content from Inapp Help Container
	 * @functionType function UI.Utils.unloadInappHelp
	 * @param {*} callback Function to be called after form removed from HTML DOM
	 */
	unloadInappHelp: function (callback) {
		let helpElement = document.getElementById('zps-inapphelpcontent')
		helpElement.classList.remove('show-inapp-slide')
		helpElement.innerHTML = ''
		UI.Utils.freezeScreen(false)
		UI.ComponentState.setState('inAppHelpContainer' , false);
		if (callback) {
			callback()
		}
	},

	/**
	 * Render the HTML Content as popup in the middile of webpage. 
	 * @functionType function UI.Utils.loadMidPop
	 * @param {*} object HTML Content
	 * @param {*} callback Function to be called after rendered
	 */
	loadMidPop: function (object, callback, popElemObj) {
		let globalPlacement = document.getElementById('zps-global-placement');
		let defaultPop = document.getElementById('zpsPopDefault').innerHTML;

		let popElementId = popElemObj?.id || "zpMidPop";
		let popElementClass = popElemObj?.class || "zps-mid-pop";

		let midPopIndex = "false";
		if (defaultPop != "") {
			midPopIndex = "true";
		}
		let popElement = createAndSetAttributes('div', { 'id': popElementId, 'class': popElementClass, 'isPopdefault': midPopIndex })
		if (object && typeof object == 'object' && object.type == 'html') {
			let htmlContent = buildHTMLFromObject(object);
			popElement.innerHTML = htmlContent;

			function buildHTMLFromObject(obj) {
				let htmlString = '';
				obj.strings.forEach((str, i) => {
					htmlString += str;
					if (obj.values[i] !== undefined) {
						if (typeof obj.values[i] === 'object' && obj.values[i].type === 'html') {
							htmlString += buildHTMLFromObject(obj.values[i]);
						} else {
							htmlString += obj.values[i];
						}
					}
				});
				return htmlString;
			}
		} else if (object) {
			object = object instanceof DocumentFragment || object.length == undefined ? [object] : object;
			UI.Utils.appendElements(object, popElement);
		}

		globalPlacement.appendChild(popElement);
		UI.ComponentState.setState('midPop' , true);
		window.FocusUtil?.focusOnFirstElement(document.getElementById("zpMidPop"));

		if (callback) {
			callback()
		}
	},

	/**
	 * Removes HTML Content from mid popup container
	 * @functionType function UI.Utils.unloadMidPop
	 * @param {*} callback Function to be called after rendered
	 */
	unloadMidPop: function (callback) {
		jqToJs.remove('#zpMidPop');
		UI.ComponentState.setState('midPop' , false);
		if (callback) {
			callback()
		}
	},
	/**
	 * Render the HTML Content as popup in the middile of webpage. 
	 * @functionType function UI.Utils.loadCMwrap
	 * @param {*} object HTML Content
	 * @param {*} callback Function to be called after rendered
	 */
	loadCMwrap: function (object, callback) {
		UI.Utils.loadMidPop(object, callback, { id: 'zpCustomModuleWrap', class: 'zps-custom-module-pop' });
	},

	/**
	 * Removes HTML Content from mid popup container
	 * @functionType function UI.Utils.unloadCMwrap
	 * @param {*} callback Function to be called after rendered
	 */
	unloadCMwrap: function (callback) {
		jqToJs.remove('#zpCustomModuleWrap');
		if (callback) {
			callback()
		}
	},
	/**
	 * Creates the preview popup container for module gallery preview.
	 * @functionType function UI.Utils.loadModuleGalleryPreviewPop
	 * @param {*} object HTML Content
	 * @param {*} callback Function to be called after rendered
	 */
	loadModuleGalleryPreviewPop: function (object, callback) {
		UI.Utils.loadMidPop(object, callback, { id: 'zpModulePreviewPop', class: 'zps-mid-pop' });
	},
	/**
	 * Removes the preview popup container for module gallery preview.
	 * @functionType function UI.Utils.unloadModuleGalleryPreviewPop
	 * @param {*} callback Function to be called after rendered
	 */
	unloadModuleGalleryPreviewPop: function (callback) {
		jqToJs.remove('#zpModulePreviewPop');
		if (callback) {
			callback()
		}
	},
	loadUpgradeAlert: function (location, object, callback) {
		let globalPlacement = document.getElementById(location);
		document.getElementsByClassName('zps-upgrade-alertbg').remove;
		let popElement = createAndSetAttributes('div', { 'id': 'zpNewUpgradeAlert', 'class': 'zps-upgrade-alertbg', 'pop-style': location ? 'true' : 'false' })
		jQuery(popElement).html(object)
		globalPlacement.appendChild(popElement);
		if (callback) {
			callback()
		}
	},
	unloadUpgradeAlert: function (callback) {
		let popElement = document.getElementById('zpNewUpgradeAlert');
		popElement && popElement.remove()
		if (callback) {
			callback()
		}
	},
	loadHangingForm: function (object, callback) {
		let formElement = document.getElementById('zpsHangingPop')
		formElement.removeAttribute('style')
		formElement.innerHTML = ''
		UI.Utils.appendElements(object, formElement);
		formElement.classList.remove('hide')
		if (callback) {
			callback()
		}
	},
	unloadHangingForm: function (callback) {
		let formElement = document.getElementById('zpsHangingPop')
		formElement.classList.add('hide')
		formElement.innerHTML = ''
		formElement.removeAttribute('style')
		if (callback) {
			callback()
		}
	},
	loadExtnPop: function (object, callback) {
		let globalPlacement = document.getElementById('zps-global-placement')
		let popElement = createAndSetAttributes('div', { 'id': 'app-pop-window', 'class': 'zps-mid-pop app-pop' })
		popElement.appendChild(createAndSetAttributes('I', { 'id': 'app-modal-close', 'class': 'zoho-close app-pop-close', 'data-tooltip': 'Close' }))
		let popData = createAndSetAttributes('div', { 'id': 'app-modal-content', 'class': 'zpspopbg' })
		UI.Utils.appendElements(object, popData);
		popElement.appendChild(popData);
		globalPlacement.appendChild(popElement);
		if (callback) {
			callback()
		}
	},
	unloadExtnPop: function (callback) {
		jqToJs.remove('#app-pop-window');
		if (callback) {
			callback()
		}
	},
	loadUnEscapeDOM: function (object, callback) {
		let globalPlacement = document.getElementById('zps-global-placement');
		let domExist = document.getElementById('zpUnescapeDom');
		object = object instanceof DocumentFragment ? [object] : object;
		if (domExist) {
			domExist.innerHTML = '';
			for (let i = 0; i < object.length; i++) {
				domExist.appendChild(object[i]);
			}
		} else {
			let domElement = createAndSetAttributes('div', { 'id': 'zpUnescapeDom', 'class': 'zps-mid-pop' })
			for (let i = 0; i < object.length; i++) {
				domElement.appendChild(object[i]);
			}
			globalPlacement.appendChild(domElement);
		}

		if (callback) {
			callback()
		}
	},

	/**
	 * Renders HTML Content in mini slider form. 
	 * @functionType function UI.Utils.loadMiniSlide
	 * @param {*} object HTML Content
	 * @param {*} callback Function to be called after rendered
	 */
	loadMiniSlide: function (object, callback) {
		let slideElement = document.getElementById('zps-inapphelpcontent')
		$L(slideElement).empty()
		slideElement.classList.add('show-inapp-slide')
		// slideElement.innerHTML = object.outerHTML;
		object = (object instanceof DocumentFragment || object.length == undefined) ? [object] : object;
		UI.Utils.appendElements(object, slideElement);
		UI.Utils.freezeScreen(true)
		UI.ComponentState.setState('inAppHelpContainer' , true);
		window.FocusUtil?.focusOnFirstElement(document.getElementById("zpsSlideItems"));
		if (callback) {
			callback()
		}
	},

	/**
	 * Removes HTML Content from mini slider form
	 * @functionType function UI.Utils.unloadMiniSlide
	 * @param {*} callback Function to be called after rendered
	 */
	unloadMiniSlide: function (callback) {
		let slideElement = document.getElementById('zps-inapphelpcontent')
		slideElement.classList.remove('show-inapp-slide')
		$L(slideElement).empty()
		UI.Utils.freezeScreen(false)
		UI.ComponentState.setState('inAppHelpContainer' , false);
		if (callback) {
			callback()
		}

	},
	convertToRem: function (value, base=15.5) {
		return parseFloat(value) * 1 / base + 'rem'; 
	},

	//type = ZCTypes.DATETIME -> Date and time
	// type = ZCTypes.DAY -> Date only
formatDate: function (input, isGMT = false, type = ZCTypes.DATETIME) {
		if (input) {
			input = !Number.isNaN(Number(input)) ? parseInt(input) : input
			// We're converting everything to upper case to support moment's format
			// we're splitting the AM/PM from the time format and 
			// adding it back manually in upper case
			var format = Utils.dateformat.toUpperCase();
			if (type == ZCTypes.DATETIME) {
				if (Utils.timeformat[0] === 'h') {
					format = format + " " + Utils.timeformat.split(' ')[0] + " a";
				} else {
					format = format + " " + Utils.timeformat.split(' ')[0];
				}
			}
			let dateandtime;
			if (isGMT) {
				dateandtime = moment.utc(input).tz(Utils.timezone).format(format);
			} else {
				dateandtime = moment.tz(moment.tz(input, Utils.hostTimezone).format('YYYY-MM-DD HH:mm:ss'), "Europe/Dublin").tz(Utils.timezone).format(format)
			}
			if (dateandtime.includes('am')) {
				return dateandtime.replace('am', getI18nValue("zp.general.am"));
			} else if (dateandtime.includes('pm')) {
				return dateandtime.replace('pm', getI18nValue("zp.general.pm"));
			} else {
				return dateandtime;
			}
		} else {
			return "Invalid input";
		}
	},

	/**
	 * Show message in toaster
	 * @functionType function UI.Utils.showToast
	 * @param {*} type toastType to be given as a param. Eg: type : 'error' 
	 * @param {*} toastObject message and time(optional) to be given as object. Eg: {messsage:'zp.error.unabletoprocess'}
	 */
	toastTimeouts: {}, // Store timeout IDs for each toast type
	showToast(type, { message = null, time = 3000 } = {}) {
		const isError = type === 'error';
		const toastContainerId = isError ? 'zpErrorMsg' : 'zpSuccessMsg';
		const toastMessageDiv = document.getElementById(toastContainerId);
		
		// Return if toast container doesn't exist
		if (!toastMessageDiv) return;

		toastMessageDiv.setAttribute("role" , "alert");
		toastMessageDiv.setAttribute("aria-atomic", true);

		// Set up default values
		const defaultMessage = isError ? 'zp.error.unabletoprocess' : 'zp.zreports.syncsuccess';
		const iconClass = isError ? 'zoho-warning-sign' : 'zoho-tick-icon';

		// Create the message content
		const toastContent = document.createDocumentFragment();
		if (message instanceof DocumentFragment) {
			toastContent.appendChild(message);
		} else {
			const textNode = document.createTextNode(message || getI18nValue(defaultMessage));
			toastContent.appendChild(textNode);
		}

		// Populate toast message div
		toastMessageDiv.innerHTML = `
			<span><i class="${iconClass}"></i></span>
			<div></div> 
			<i class="zoho-close toast-close"></i>
		`;
		toastMessageDiv.querySelector('div').appendChild(toastContent);
		toastMessageDiv.classList.add('toast-open');

		// Add click listener to close button
		toastMessageDiv.querySelector('.toast-close').addEventListener('click', () => this.closeToast(type, 400));

		time = message ? this.calculateReadTime(message) : time;
		// Auto-hide after specified time
		if (UI.Utils.toastTimeouts[type]) clearTimeout(UI.Utils.toastTimeouts[type]);

		// Set new timeout
		UI.Utils.toastTimeouts[type] = setTimeout(() => UI.Utils.closeToast(type, 100), time);
	},
	closeToast(type, delay = 0, callback) {
		const toastContainerId = type === 'error' ? 'zpErrorMsg' : 'zpSuccessMsg';
		const toastDiv = document.getElementById(toastContainerId);

		if (toastDiv) {
			toastDiv.classList.remove('toast-open');
			setTimeout(() => {
				toastDiv.innerHTML = '';
				if (callback && typeof callback === 'function') callback();
			}, delay);
			if (UI.Utils.toastTimeouts[type]) {
				clearTimeout(UI.Utils.toastTimeouts[type]);
				delete UI.Utils.toastTimeouts[type];
			}
		}
	},
	calculateReadTime(text) {
		const wordsPerMinute = 265; // Medium's average reading speed
		const minimumDisplayTime = 3000; // Minimum display time in milliseconds
		if (text instanceof HTMLElement) {
			text = text.innerText || text.textContent; // Get plain text
		}
		else if (text instanceof DocumentFragment) {
			// If text is a DocumentFragment, extract text from its child nodes
			text = Array.from(text.childNodes).map(child => child.textContent).join('');
		}
		const words = text.trim().split(/\s+/).length; // Count words
		const readTimeInMilliseconds = Math.ceil((words / wordsPerMinute) * 60 * 1000); // Convert minutes to ms

		// Ensure minimum display time is respected
		return Math.max(readTimeInMilliseconds, minimumDisplayTime);
	},
	/**
	 * Show Error message in toaster
	 * @functionType function UI.Utils.showError
	 * @param {*} errorObject message and time(optional) to be given as object. Eg: {messsage:'zp.error.unabletoprocess'}
	 */
	showError: function (errorObject) {
		var errorObject = errorObject ? errorObject : {}
		errorObject.message = getI18nValue(errorObject.message ? errorObject.message : 'zp.error.unabletoprocess') //NO I18N
		UI.Utils.showToast('error', errorObject);
	},
	/**
	 * Show success message in toaster
	 * @functionType function UI.Utils.showSuccess
	 * @param {*} successObject message and time(optional) to be given as object. Eg: {messsage:'zp.error.unabletoprocess'}
	 */
	showSuccess: function (successObject) {
		var successObject = successObject ? successObject : {}
		successObject.message = getI18nValue(successObject.message ? successObject.message : 'zp.zreports.syncsuccess') //NO I18N
		UI.Utils.showToast('success', successObject);
	},

	saveDashTabOrder: function (moduleName, refreshPage) {
		//let parentElem = document.getElementById('customdashSort');
		let widgetArray = document.querySelectorAll('.customdashSort-list');
		let dataArray = [];
		widgetArray.forEach(function (element) {
			let widget_id = element.getAttribute('widget_id')
			let order = element.getAttribute('order')
			let checkId = 'dashcheckorder' + order;
			let visibility = element.querySelectorAll('[id=' + checkId + ']')[0].getAttribute('value');
			let entry = {};
			entry[widget_id] = visibility;
			dataArray.push(entry);

		})


		if (refreshPage) {
			document.querySelector('#dashsaveorder .zps-primary-button').setAttribute('zps-loader', 'yes');
		}
		switch (moduleName) {

			case 'portfolio':
				ajaxRequest({
					url: PortfolioDashboard.URLs.updateWidgetPreference(),
					type: _POST,
					args: {
						order: JSON.stringify(dataArray)
					},
					apiVersion: _V3,
				}).then(function (responseData) {
					if (refreshPage) {
						PortfolioDashboard.UI.Actions.showPortfolioPage()
					}
				}).catch(function (error) {
					console.log(error);
				});
		}

	},
	/**
	 * Show HTML Element
	 * @functionType function UI.Utils.show
	 * @param {*} selectors valid selector to be matched
	 */
	show: function () {
		for (var i = 0; i < arguments.length; i++) {
			var element = document.querySelector(arguments[i]);
			if (element) {
				element.style.display = 'block';
			}
		}
	},

	/**
	 * Hide HTML Element
	 * @functionType function UI.Utils.hide
	 * @param {*} selectors valid selector to be matched
	 */
	hide: function () {
		for (var i = 0; i < arguments.length; i++) {
			var element = document.querySelector(arguments[i]);
			if (element) {
				element.style.display = 'none';
			}
		}
	},
	/**
	 * Removes HTML Content from the given selectors
	 * @functionType function UI.Utils.empty
	 * @param {*} selectors valid selector to be matched
	 */
	empty: function () {
		for (var i = 0; i < arguments.length; i++) {
			var element = document.querySelector(arguments[i]);
			if (element) {
				$L(element).empty()
			}
		}
	},
	/**
	 * Focus the HTML Element for the given selector
	 * @functionType function UI.Utils.focus
	 * @param {*} selectors valid selector to be matched
	 */
	focus: function (selector) {
		var element = document.querySelector(selector);
		if (element) {
			element.focus();
			if (element.nodeName === 'INPUT') {
				var value = ''
				value = element.value
				element.value = ''
				element.value = value
			}
		}
	},
	/**
	 * Removes HTML Element from DOM
	 * @functionType function UI.Utils.remove
	 * @param {*} selectors valid selector to be matched
	 */
	remove: function () {
		for (var i = 0; i < arguments.length; i++) {
			var element = document.querySelector(arguments[i]);
			element && element.parentNode && element.parentNode.removeChild(element)
		}
	},
	removeFrom: function (parentNode) {
		var parentNode = parentNode || document
		for (var i = 1; i < arguments.length; i++) {
			var nodeList = parentNode.querySelectorAll(arguments[i]);
			nodeList.forEach(function (element) {
				element && element.parentNode && element.parentNode.removeChild(element)
			})
		}
	},

	/**
	 * Add class to the given HTML element
	 * @functionType function UI.Utils.addClass
	 * @param {string} selector selector value to be matched
	 * @param {string} className value to be added to class attribute
	 */
	addClass: function (selector, className) {
		var elements = document.querySelectorAll(selector);
		elements.forEach(function (item) {
			if (!item.classList.contains(className)) {
				item.classList.add(className);
			}
		});
	},

	/**
	 * Removes given class from the HTML element
	 * @functionType function UI.Utils.removeClass
	 * @param {string} selector selector value to be matched
	 * @param {string} className value to be removed from class attribute
	 */
	removeClass: function (selector, className) {
		var elements = document.querySelectorAll(selector);
		elements.forEach(function (item) {
			item.classList.remove(className);
		});
	},
	fadeOut: function () {
		for (var i = 0; i < arguments.length; i++) {
			var element = document.querySelector(arguments[i]);
			if (element) {
				jQuery(element).fadeOut();
			}
		}
	},
	isVisible: function (selector) {
		var element = document.querySelector(selector);
		return (element && $L(element).is(":visible"))
	},
	toggle: function (target, makeElementVisible) {
		let element = target instanceof Element ? target : document.querySelector(target);
		if (element) {
			element.style.display = makeElementVisible ? '' : 'none';
		}
	},
	renderTemplate: function (selector, templateName, data) {
		var element = document.querySelector(selector);
		if (element && templateName) {
			element.innerHTML = '';
			let template = jQuery.tmpl(templateName, data);
			UI.Utils.appendElements(template, element);
		}
	},
	getTemplate: function (templateName, data) {
		return jQuery.tmpl(templateName, data);
	},
	appendTemplate: function (selector, templateName, data) {
		var element = document.querySelector(selector);
		if (element && templateName) {
			let template = jQuery.tmpl(templateName, data);
			UI.Utils.appendElements(template, element);
		}
	},
	/**
	 * @functionType function UI.Utils.getLabelTextForIcon
	 * @param {string} name 
	 * @returns {string}
	 */
	getLabelTextForIcon: function (name) {
		if (name && name.length > 0) {
			name = name.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '')
			name = name.replace(/^\s+/g, '');
			var label = '';
			var splitArray = name.split(' ')
			if (splitArray.length == 1) {
				label = (splitArray[0].length == 1) ? splitArray[0].charAt(0) : (splitArray[0].charAt(0) + splitArray[0].charAt(1));
				if (label.length == 0) {
					label += `<span class=zoho-unknown-sp-char></span>`;
				}
			} else {
				var i = 0;
				var j = 0;
				while (j++ < 20 && i < 2) {
					if (splitArray[i] && splitArray[i].charAt(0).match(/^[0-9a-zA-Z_\-+.@$?,:'\/!\[\]|&\u0080-\uFFFF\s]+$/)) {
						label += splitArray[i].charAt(0);
						i++;
					}
				}
			}
			return label;
		}
	},
	getTagColors: (data) => {
		return data['tags'].map(function (x) { return x.color_hexcode });
	},
	getRandomColor: function (id) {
		return ['#a6cd3e', '#33d2cc', '#9a81fa', '#2492ad', '#0652dd', '#dd0673', '#a6cd3e', '#2492ad', '#33d2cc', '#9a81fa'][parseInt(id.charAt(id.length - 1))]
	},
	animateNumber: function (element) {
		if (element == undefined || $L(element).text() == undefined || $L(element).text === '') {
			return;
		}
		$L(element).prop('Counter', 0)
		jQuery(element).animate({
			Counter: $L(element).text()
		}, {
			duration: 1500,
			easing: 'swing',
			step: function (now) {
				var tempVal = UI.Utils.insertComma(Math.floor(now));
				if (!Number.isNaN(tempVal)) {
					$L(element).text(tempVal);
				}
			}
		})
	},
	insertComma: function (val) {
		while (/(\d+)(\d{3})/.test(val.toString())) {
			val = val.toString().replace(/(\d+)(\d{3})/, '$1' + ',' + '$2');
		}
		return val;
	},

	CopyPageURLToClipBoard: function (url) {
		const extFrame = document.body.getAttribute("ext-frame")
		if (isProjectsPlus && crmpluslibcheck) {
			url = url.contains(window.location.search) ? url.replace(window.location.search, "") : url;
		}
		if (extFrame) {
			url = IntegrationUtil.ContextMenuHandler.handle('CopyLink', { 'url': url });
		}
		UI.Utils.CopyToClipBoardAsText(url)
	},

	CopyToClipBoardAsText: function (text) {
		const extFrame = document.body.getAttribute("ext-frame")
		if (extFrame) {
			var textarea = document.createElement("textarea");
			textarea.value = text;
			document.body.appendChild(textarea);
			textarea.select();
			document.execCommand("copy");
			document.body.removeChild(textarea);
		} else {
			navigator.clipboard.writeText(text);
		}
		UI.Utils.showSuccess({ message: getI18nValue("zp.webtobugform.clipboard") });
	},

	createCopyLinkIcon: function (urlFn) {
		const wrapper = createAndSetAttributes('span', { class: 'zps-copy-link-btn ml15' }); //NO I18N
		const icon = createAndSetAttributes('i', { class: 'zoho-copy' }); //NO I18N
		const text = document.createTextNode(getI18nValue('zp.copy.link'));
		wrapper.appendChild(icon);
		wrapper.appendChild(text);
		wrapper.addEventListener('click', function () {
			const url = typeof urlFn === 'function' ? urlFn() : urlFn;
			if (url) {
				UI.Utils.CopyPageURLToClipBoard(url);
			}
		});
		return wrapper;
	},

	copytoclipboard: function (selector) {
		let selectorElement = document.querySelector(selector)

		if (!selectorElement) { return; }

		let content = isInputElement(selectorElement) ? selectorElement.value : selectorElement.textContent

		// If the browser has clipboardData API Support, use that
		if (window.clipboardData && window.clipboardData.setData) {
			if (clipboardData.setData("Text", content)) {
				showSuccess()
			}
			return;
		}
		// Else resort to tricks
		// If the element is visible do this
		if (isInputElement(selectorElement) && selectorElement.offsetWidth > 0 && selectorElement.offsetHeight > 0) {
			selectorElement.classList.add("select");
			selectorElement.select();
			document.execCommand("copy");
			selectorElement.classList.remove("select");
		}
		else {
			var textarea = document.createElement("textarea");
			textarea.value = content;
			document.body.appendChild(textarea);
			textarea.select();
			document.execCommand("copy");
			document.body.removeChild(textarea);
		}
		showSuccess()

		function showSuccess() {
			UI.Utils.showSuccess({ message: getI18nValue("zp.webtobugform.clipboard") });
		}

		function isInputElement(element) {
			return (element.tagName === 'INPUT' || element.tagName === 'TEXTAREA');
		}
	},

	toggleZPSLoader: function (buttonObj, mode = true) {
		if (buttonObj === undefined) { //close all loaders
			jQuery('[zps-loader=yes]').attr('zps-loader', '');
			return false;
		}
		if (jQuery(buttonObj).hasAttr('zps-loader')) {
			if (mode) {
				jQuery(buttonObj).attr('zps-loader', 'yes');
			} else {
				jQuery(buttonObj).attr('zps-loader', 'no');
			}
		}
		return false;
	},

	appendElements: function (object, element) {
		if (object) {
			for (let i = 0; i < object.length; i++) {
				if (object[i]?.tagName == 'SCRIPT') {
					const script = document.createElement('script');
					script.type = 'text/javascript';
					script.text = object[i].textContent;
					element.appendChild(script);
				} else {
					element.appendChild(object[i]);
				}
			}
		}
	},

	// Color Conversion Utils
	// Convert Hex to [r, g, b]
	hexToRgb(hex) {
		var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
		hex = hex.replace(shorthandRegex, function (m, r, g, b) {
			return r + r + g + g + b + b;
		});

		var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
		return result ? [
			parseInt(result[1], 16),
			parseInt(result[2], 16),
			parseInt(result[3], 16)
		] : null;
	},

	// Convert [r, g, b] to hex
	rgbToHex(r, g, b) {
		const toHex = n => Math.max(0, Math.min(255, n)).toString(16).padStart(2, '0');
		return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
	},

	// Convert [r, g, b] to "rgb(r, g, b)"
	rgbToRgbString(r, g, b) {
		if ([r, g, b].some(v => v === undefined || isNaN(v))) {
			console.warn('Invalid RGB values:', r, g, b);
			return 'rgb(0, 0, 0)';
		}
		return `rgb(${r}, ${g}, ${b})`;
	},

	// Convert hex to "rgb(r, g, b)"
	hexToRgbStr(hex) {
		const rgb = this.hexToRgb(hex);
		return rgb ? this.rgbToRgbString(...rgb) : null;
	},

	// Convert "rgb(r, g, b)" to [r, g, b]
	rgbStringToArray(rgbString) {
		const result = rgbString.match(/\d+/g);
		return result ? result.map(Number) : null;
	},

	// Convert "rgb(r, g, b)" to hex
	rgbStringToHex(rgbString) {
		const rgb = this.rgbStringToArray(rgbString);
		return rgb ? this.rgbToHex(...rgb) : null;
	},

	// Convert "rgb(r, g, b)" to "r, g, b"
	rgbStringToRgbValue(rgbString) {
		const values = this.rgbStringToArray(rgbString);
		return values ? values.join(', ') : null;
	},
	getLuminance(hexColor) {
		// Fallback to white if hexColor is null or not a valid string
		if (!hexColor || typeof hexColor !== 'string' || !/^#([0-9a-fA-F]{6})$/.test(hexColor)) {
			hexColor = '#ffffff'; // white has a luminance of 1
		}

		const r = parseInt(hexColor.substr(1, 2), 16) / 255;
		const g = parseInt(hexColor.substr(3, 2), 16) / 255;
		const b = parseInt(hexColor.substr(5, 2), 16) / 255;

		const [R, G, B] = [r, g, b].map(c => {
			return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
		});

		const luminance = 0.2126 * R + 0.7152 * G + 0.0722 * B;
		return luminance;
	},
	textColorOnLuminance(hexColor) {
		const colorExtract = convertToHexColorTemp(hexColor);
		const luminanceValue = UI.Utils.getLuminance(colorExtract);
		if (!colorExtract || colorExtract === 'transparent') {
			return 'rgb(var(--zpOnData))';
		}
		return luminanceValue < 0.5 ? '#ffffff' : '';
	},
	setupResizer(parentElement) {
		// .zp-resizable-container
		document.querySelectorAll(parentElement).forEach(parent => {
			const resizer = parent.querySelector('.zp-resizable-divider');
			const resizeStart = parent.querySelector('.zp-resizable-panel-start');
			const resizeEnd = parent.querySelector('.zp-resizable-panel-end');

			const isVertical = parent.classList.contains('is-vertical');
			const cursorType = isVertical ? 'row-resize' : 'col-resize';
			const direction = isVertical ? 'Y' : 'X';

			resizer.style.cursor = cursorType;

			let isDragging = false;

			resizer.addEventListener('mousedown', function (e) {
				e.preventDefault();
				isDragging = true;

				const startPos = direction === 'Y' ? e.clientY : e.clientX;
				const startSize = isVertical
					? resizeStart.getBoundingClientRect().height
					: resizeStart.getBoundingClientRect().width;
				const parentSize = isVertical
					? parent.getBoundingClientRect().height
					: parent.getBoundingClientRect().width;

				function onMouseMove(e) {
					if (!isDragging) return;

					const currentPos = direction === 'Y' ? e.clientY : e.clientX;
					let delta = currentPos - startPos;
					let newSize = startSize + delta;

					// Clamp size
					newSize = Math.max(30, Math.min(newSize, parentSize - 30));

					resizeStart.style.flex = 'none';
					resizeEnd.style.flex = '1';

					if (isVertical) {
						resizeStart.style.height = newSize + 'px';
						resizeEnd.style.height = 'auto';
					} else {
						resizeStart.style.width = newSize + 'px';
						resizeEnd.style.width = 'auto';
					}
				}

				function onMouseUp() {
					isDragging = false;
					document.removeEventListener('mousemove', onMouseMove);
					document.removeEventListener('mouseup', onMouseUp);
				}

				document.addEventListener('mousemove', onMouseMove);
				document.addEventListener('mouseup', onMouseUp);
			});
		});
	}
}

function failureMsg(msg, showclose, timeoutSecs) {
	if (document.querySelectorAll('.zpfailure').length == 0) {
		let mainDiv = createAndSetAttributes('div', { class: 'zpfailure' });
		let lhsDiv = createAndSetAttributes('div', { class: 'zpfailure_lhs' });
		let span = createAndSetAttributes('span', { class: 'zoho-warning-sign T2 posrel' });
		let rhsDiv = createAndSetAttributes('div', { class: 'zpfailure_rhs' });
		rhsDiv.innerHTML = msg;
		lhsDiv.appendChild(span);
		mainDiv.appendChild(lhsDiv);
		mainDiv.appendChild(rhsDiv);
		document.body.appendChild(mainDiv);
	}
	else {
		clearTimeout(myVar);
		document.querySelector('.zpfailure_rhs').innerHTML = msg;
	}

	if (document.querySelector('#announceMain') != null) {
		document.querySelector('.zpfailure').style.top = '71px';
	}
	if ($L("#bugdetpopdiv").is(":visible") || $L("#ntdetid").is(":visible")) {
		document.querySelector('.zpfailure').style.top = '8px';
	}
	if ((typeof crmpluslibcheck != "undefined" && crmpluslibcheck) || $L("#ntldetid").is(":visible")) {
		document.querySelector('.zpfailure').style.top = '0px';
	}
	if (!showclose) {
		if (timeoutSecs == null) {
			timeoutSecs = 3000;
		}
		//setTimeout(function() { jQuery('.zpfailure').addClass('zpfailure_hide') },timeoutSecs);
		//timeoutSecs +=300;
		myVar = setTimeout(function () { jqToJs.remove('.zpfailure') }, timeoutSecs);
	}
	else {
		if (timeoutSecs == null) {
			timeoutSecs = 5000;
		}
		if (document.querySelector('.zpfailure_close') == null) {
			let zpFailureClose = createAndSetAttributes('div', { class: 'zpfailure_close' });
			let closeSpan = createAndSetAttributes('span', { class: 'zoho-close T1 posrel col666 fs11px' });
			zpFailureClose.appendChild(closeSpan);
			document.querySelector('.zpfailure').appendChild(zpFailureClose);
		}
		myVar = setTimeout(function () { jqToJs.remove('.zpfailure') }, timeoutSecs);
		$L('.zpfailure_close').click(function () { jqToJs.remove('.zpfailure'); clearTimeout(myVar); });
	}

}

/**
* Toggle show hide between two HTML Element
* @param {*} showElem HTML Element 1
* @param {*} hideElem HTML Element 2
*/
function toggleSwitchHide(showElem, hideElem) {
	var showElem = document.getElementById(showElem);
	var hideElem = document.getElementById(hideElem);
	if (showElem.classList.contains("hide")) {
		showElem.classList.remove("hide"); hideElem.classList.add("hide");
	} else {
		showElem.classList.add("hide"); hideElem.classList.remove("hide");
	}
}

/**
* Shake the button for attention
* @param {string} prop Selector type. Allowed types(id, class, name, element)
* @param {*} target Selector
*/
function attentionClick(prop, target) {
	let targetElem = '';
	switch (prop) {
		case "id":
			targetElem = document.querySelector('#' + target);
			break;
		case "class":
			targetElem = document.querySelector('.' + target);
			break;
		case "name":
			targetElem = document.querySelector('[name=' + target + ']');
			break;
		case "element":
			targetElem = target;
			break;
		default:
			break;
	}
	targetElem.removeAttribute('attention');
	targetElem.offsetWidth = targetElem.offsetWidth;
	targetElem.setAttribute('attention', 'true');
}

/**
* Append ZCTemplate to target HTML element
* @functionType function ZCTemplates.append
* @param {*} html HTML Elements
* @param {*} targetElement HTML selecor or element
*/
typeof ZCTemplates !== 'undefined' ? ZCTemplates.append = (html, targetElement) => {
	let div = document.createElement('div');
	ZCTemplates.renderView(html, div);
	targetElement = typeof targetElement == "string" ? jQuery(document.querySelector(targetElement)) : (targetElement instanceof Element ? jQuery(targetElement) : targetElement)
	if (!targetElement) { return; }
	while (div.children.length > 0) {
		targetElement.append(div.children[0]);
	}
} : console.warn("ZCTemplates not loaded");




function ShowHideBlock(divId, Id, focusId) {
	var id = document.getElementById(divId);
	if (id) {
		id.className = 'block';
		if (focusId) {
			setFocus(focusId);
		}
	}
	var id1 = document.getElementById(Id);
	if (id1) {
		id1.className = 'hide';
	}
}


function showHide(divId1, divId2) {
	var id1 = document.getElementById(divId1);
	var id2 = document.getElementById(divId2);
	id1.style.display = "block";
	id2.style.display = "none";
}

function ShowHideBlockGeneral(divId, Id, focusId) {
	var id = document.getElementById(divId);
	if (id) {
		id.classList.add('block');
		id.classList.remove('hide');
		if (focusId) {
			setFocus(focusId);
		}
	}
	var id1 = document.getElementById(Id);
	if (id1) {
		id1.classList.add('hide');
		id1.classList.remove('block');
	}
}

function ShowHideInline(divId, divId2) {
	var id = document.getElementById(divId);
	if (id) {
		id.className = 'inline';
	}

	var id1 = document.getElementById(divId2);
	if (id1) {
		id1.className = 'hide';
	}
}

function showHideMultipleDiv(showDiv, divIds) {
	var id1 = document.getElementById(showDiv);
	id1.style.display = "block";
	var id2;
	for (var i = 0; i < divIds.length; i++) {
		id2 = document.getElementById(divIds[i]);
		id2.style.display = "none";
	}
}

function showHideByClass(elem1, elem2) {
	document.getElementById(elem1)?.classList.remove('hide');
	document.getElementById(elem2)?.classList.add('hide');
}

function ShowGenBlock(divId) {
	if ((typeof IsWPloaded == "undefined" || !IsWPloaded) && (typeof crmpluslibcheck != "undefined" && crmpluslibcheck) && divId === "ajax_load_tab") {
		CrmPlusLib.showLoading()
		setTimeout(function () { CrmPlusLib.hideLoading() }, 1500);
	} else {

		// if (divId === "ajax_load_tab") {
		// 	$L("#" + divId).show();
		// 	document.querySelector("#" + divId).style.width = "0%";
		// 	$L("#" + divId).animate({ 
		// 		width: "100%"
		// 	}, 1500, function () { $L(this).hide(); });
		// 	return false;
		// }

		var id = document.getElementById(divId);
		id?.classList.remove('hide');
	}
}

function Hide(divId) {
	if (divId === "ajax_load_tab" && !$L("#homeheader").is(":visible")) {
		divId = "ajax_load_tab_max";
	}

	// if (divId === "ajax_load_tab") {
	// 	$L("#ajax_load_tab").animate({	
	// 		width: "100%"
	// 	}, 10, function () { $L("#ajax_load_tab").hide(); });	

	// 	return false;
	// }

	var id = document.getElementById(divId);
	if (id) {
		id.className = 'hide';
	}
}

function dispNone(divId) {
	var id = document.getElementById(divId);
	if (id) {
		id.style.display = 'none';
	}
}

function setShowHide(divId) {
	let classList = document.getElementById(divId).classList;
	classList.contains('hide') ? classList.remove('hide') : classList.add('hide');
}

function dispBlock(divId) {
	var id = document.getElementById(divId);
	if (id) {
		id.style.display = 'block';
	}
}

function replaceWithClass(selector, oldClass, newClass) {
	selector.removeClass(oldClass).addClass(newClass);
}

function setRemoveClass(divId, addclass, rmclass) {
	document.getElementById(divId).classList.add(addclass);
	document.getElementById(divId).classList.remove(rmclass);
}

function SwapDivClasses(divId, divId1, addclass, rmclass) {
	setRemoveClass(divId, addclass, rmclass);
	setRemoveClass(divId1, rmclass, addclass);
}

function setAsVisible(id) {
	var obj = document.getElementById(id);
	if (obj) {
		obj.style.visibility = 'visible';
	}
}

function changeElementClass(id, styleName) {
	var elemId = document.getElementById(id);
	if (elemId != null) {
		elemId.className = styleName;
	}
}

function switchHide(showElem, hideElem) {
	document.getElementById(showElem).classList.remove('hide');
	document.getElementById(hideElem).classList.add('hide');
}

function setHide(elem) {
	document.getElementById(elem)?.classList.add('hide');
}
function removeHide(elem) {
	document.getElementById(elem)?.classList.remove('hide');
}

function Show(divId) {
	var id = document.getElementById(divId);
	if (id) {
		id.className = 'inline';
	}
}

function ChangeClass(id, className) {
	document.getElementById(id).className = className;
}

function ForceShowGenInline(divId) {
	// if (divId === "ajax_load_tab") {
	// 	$L("#ajax_load_tab").show()	
	// 	document.querySelector("#ajax_load_tab").style.width = "0%";	
	// 	$L("#ajax_load_tab").animate({ 
	// 		width: "100%"
	// 	}, 1500, function () { $L(this).hide(); });
	// 	return false;
	// }
}

function ShowGenInline(divId) {
	if ((typeof crmpluslibcheck != "undefined" && crmpluslibcheck) && divId === "ajax_load_tab" && (typeof IsWPloaded == "undefined" || !IsWPloaded)) {
		CrmPlusLib.showLoading()
		setTimeout(function () { CrmPlusLib.hideLoading() }, 1500);
	} else {

		// if (divId === "ajax_load_tab") {
		// 	$L("#ajax_load_tab").show()	
		// 	document.querySelector("#ajax_load_tab").style.width = "0%";	
		// 	$L("#ajax_load_tab").animate({ 
		// 		width: "100%"
		// 	}, 1500, function () { $L(this).hide(); });
		// 	return false;
		// }

		var id = document.getElementById(divId);
		if (divId === "tlist_closePanel") {
			//		id.className='zoho-back pointer fs18px';
		} else if (id) {
			id.className = 'inline';//id.style.display = 'inline';
		}
	}
}

function loadAjaxTab(str) {
	var divId = document.getElementById('ajax_load_tab');
	ShowGenBlock('ajax_load_tab');
}

function ajaxLoading() {
	// $L("#ajax_load_tab").show();	
	// document.querySelector("#ajax_load_tab").style.width = "0%";	
	// $L("#ajax_load_tab").animate({  
	// 	width: "100%"
	// }, 1500, function () { $L(this).hide(); } 
	// );
}

function showAccessDenied(id, errorCode) {
	jQuery("#" + id).html(jQuery.tmpl("bugerror", { code: errorCode != null ? 6405 : 6401 }));
	removeHide(id);
}

function insertAfter(newNode, existingNode) {
	existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling)
}

const KPIAutoFitText = {
	config: {
		minFontSize: 16,
		maxFontSize: 500
	},

	init(selector, options = {}) {
		this.config = { ...this.config, ...options };

		document.querySelectorAll(selector).forEach(widget => {
			const value = widget.querySelector('.zp-text-auto-fit');
			if (!value) return;

			this._setup(widget, value);
		});
	},

	_setup(widget, value) {
		const kpiCont = widget.closest('.custdb-kpi-widgcont');
		const isGridWidget = kpiCont && kpiCont.closest('.grid-stack-item');

		// For dashboard grid: widget has real dimensions from the grid cell
		// For reports/create view: compute available space from the chart container
		const observeEl = (!isGridWidget && kpiCont && kpiCont.parentElement && kpiCont.parentElement.clientWidth > 0)
			? kpiCont.parentElement
			: widget;

		let lastW = 0, lastH = 0;
		let rafId = null;

		const resize = () => {
			const { w, h } = this._getAvailableSpace(widget, kpiCont, isGridWidget, observeEl);
			if (!w || !h) return;

			if (w === lastW && h === lastH) return;
			lastW = w;
			lastH = h;

			cancelAnimationFrame(rafId);
			rafId = requestAnimationFrame(() => {
				value.style.fontSize = this._calculateFontSize(value, w, h) + 'px';
			});
		};

		new ResizeObserver(resize).observe(observeEl);
		resize();
	},

	/**
	 * Returns the actual available width/height for the KPI value text.
	 * For grid widgets, the autofit container has real dimensions.
	 * For reports view, the autofit container is auto-sized (chicken-and-egg),
	 * so we derive available space from the chart container minus CSS constraints.
	 */
	_getAvailableSpace(widget, kpiCont, isGridWidget, observeEl) {
		if (isGridWidget || !kpiCont || observeEl === widget) {
			return { w: widget.clientWidth, h: widget.clientHeight };
		}

		const chartContainer = observeEl;
		const s = getComputedStyle(kpiCont);

		// max-width on .custdb-kpi-widgcont (e.g. "90%")
		const maxW = s.maxWidth;
		const widthFraction = (maxW && maxW.endsWith('%')) ? parseFloat(maxW) / 100 : 1;

		const padX = (parseFloat(s.paddingLeft) || 0) + (parseFloat(s.paddingRight) || 0);
		const padY = (parseFloat(s.paddingTop) || 0) + (parseFloat(s.paddingBottom) || 0);
		const marginTop = parseFloat(s.marginTop) || 0;
		const gap = parseFloat(s.gap) || 0;

		// Label may be visible (dashboard edit) or hidden (reports view)
		const label = kpiCont.querySelector('.custdb-kpi-widg-label');
		const labelH = (label && label.offsetHeight > 0) ? label.offsetHeight + gap : 0;

		const availW = chartContainer.clientWidth * widthFraction - padX;
		const availH = chartContainer.clientHeight - marginTop - padY - labelH;

		return { w: Math.max(availW, 100), h: Math.max(availH, 50) };
	},

	_calculateFontSize(value, maxW, maxH) {
		const { minFontSize, maxFontSize } = this.config;

		const clone = value.cloneNode(true);
		clone.style.position = 'absolute';
		clone.style.visibility = 'hidden';
		clone.style.whiteSpace = 'nowrap';
		document.body.appendChild(clone);

		let low = minFontSize, high = maxFontSize, best = minFontSize;

		while (low <= high) {
			const mid = (low + high) >> 1;
			clone.style.fontSize = mid + 'px';

			if (clone.scrollWidth <= maxW && clone.scrollHeight <= maxH) {
				best = mid;
				low = mid + 1;
			} else {
				high = mid - 1;
			}
		}

		// For short values, ensure font is at least 45% of container height,
		// but only if the text actually fits at that size (don't overflow for long text)
		const minVisualSize = maxH * 0.45;
		if (best < minVisualSize) {
			clone.style.fontSize = minVisualSize + 'px';
			if (clone.scrollWidth <= maxW && clone.scrollHeight <= maxH) {
				best = minVisualSize;
			}
		}

		clone.remove();
		return Math.max(best, minFontSize);
	}
};

//Creation of Jquery Alternatives For Timer 
const jqToJs = JqueryToJavascript();
function JqueryToJavascript() {

	function slideToggleAction(div) {
		let element = document.getElementById(div);
		if (element.classList.contains("hide") || element.style.display == "none") {
			element.style.display = "block";
			element.classList.remove("hide");
		}
		else {
			element.style.display = "none";
		}

	}

	function hideAndShowAnotherDiv(divToHide, divToShow) {
		let elementToHide = document.getElementById(divToHide);
		let elementToShow = document.getElementById(divToShow);

		if (elementToHide != null) {
			elementToHide.classList.add("hide");
		}
		if (elementToShow != null) {
			elementToShow.classList.remove("hide");
		}

	}

	function classToggleAction(div, toggleClass) {
		let element = document.getElementById(div);
		if (element != null) {
			if (element.classList.contains(toggleClass)) {
				element.classList.remove(toggleClass);
			}
			else {
				element.classList.add(toggleClass);
			}
		}
	}

	function classSwitchAction(div, toggleClass1, toggleClass2) {
		let element = document.getElementById(div);
		if (element != null) {
			if (element.classList.contains(toggleClass1)) {
				element.classList.remove(toggleClass1);
				element.classList.add(toggleClass2);
			}
			else {
				element.classList.remove(toggleClass2);
				element.classList.add(toggleClass1);
			}
		}
	}

	function visibilityCheck(elementId) {
		if ((document.getElementById(elementId) == null) || (document.getElementById(elementId).offsetWidth == 0 && document.getElementById(elementId).offsetHeight == 0)) {
			return false;
		}
		else {
			return true;
		}

	}

	function removeClass(elementId, className) {
		if (document.getElementById(elementId) != null) {
			document.getElementById(elementId).classList.remove(className);
		}

	}

	function remove(input) {
		let elements = getTargetElements(input);

		if(typeof lyteDomObj != 'undefined'	&& elements instanceof lyteDomObj){		//no i18n
			elements.each((index, element) => {
				element?.parentNode.removeChild(element)
			});
		} else {
			elements.forEach(element => {
				element?.parentNode.removeChild(element)
			});
		}
	}

	function append(input, elementToAppend) {
		let elements = getTargetElements(input);
		let appendElements = getElements(elementToAppend);
		elements.forEach(element => {
			appendElements.forEach(appendElement => element.append(appendElement.cloneNode(true)));
		});
	}

	function prepend(input, elementToPrepend) {
		let elements = getTargetElements(input);
		let prependElements = getElements(elementToPrepend);
		elements.forEach(element => {
			for (let i = prependElements.length - 1; i >= 0; i--) {
				element.prepend(prependElements[i].cloneNode(true))
			}
		});
	}

	function getElements(input) {
		if (input instanceof Element || input instanceof DocumentFragment) {
			return [input];
		} else if(typeof input == "string"){
			const templateElement = document.createElement('template');	//no i18n
			templateElement.innerHTML = input;
			return templateElement.content.childNodes
		} else if(input instanceof HTMLCollection){
			return [...input];
		} else if (input instanceof Array) {
			return input;
		} else if(input instanceof lyteDomObj || input instanceof $L){
			return Array.from(input);
		}
	}

	function getTargetElements(input) {
		if (input instanceof Element) {
			return [input];
		} else if(input instanceof lyteDomObj || input instanceof $L){
			return Array.from(input);
		} else if (input instanceof Object) {
			return input;
		}  else {
			return document.querySelectorAll(input);
		}
	}

	function clone(input) {
		let element = getTargetElements(input);
		return element && element[0] && element[0].cloneNode(true);
	}

	function getNthAncestor(element, n) {
		let current = element;
		while (n >= 0 && current) {
			current = current.parentNode;
			n--;
		}
		return current;
	}

	function serializeForm(form) {
		const formElement = typeof form === 'string' ? document.querySelector(form) : form;
		if (!formElement || !formElement.elements) return '';
		return new URLSearchParams(new FormData(formElement)).toString();
	}

	function serializeArray(form) {
		const formElement = typeof form === 'string' ? document.querySelector(form) : form;
		if (!formElement || !formElement.elements) return '';
		return Array.from(new FormData(formElement)).map(([name, value]) => ({
			name,
			value
		}));
	}

	function after(selector, elementToAppend) {
		const targetElement = document.querySelector(selector);
		elementToAppend = getElements(elementToAppend);
		if (targetElement && targetElement.parentNode && elementToAppend) {
			elementToAppend.forEach(element => targetElement.parentNode.insertBefore(element, targetElement.nextSibling));
		}
	}

	function before(selector, elementToAppend) {
		const targetElement = document.querySelector(selector);
		elementToAppend = getElements(elementToAppend);
		if (targetElement && elementToAppend) {
			elementToAppend.forEach(element => targetElement.before(element));			
		}
	}

	function insertAfter(input, elementToAppend){
		const targetElement = input instanceof Element ? input : document.querySelector(input);
		const parent = targetElement.parentNode;
		elementToAppend = getElements(elementToAppend);
		elementToAppend.forEach(element => {
			parent.insertBefore(element.cloneNode(true), targetElement);
		});
	}

	function debounce(func, wait, immediate) {
		let timeout;
		return function () {
			const context = this;
			const args = arguments;
			const later = function () {
				timeout = null;
				if (!immediate){
					func.apply(context, args);
				}
			};
			const callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if(callNow) {
				func.apply(context, args);
			}
		};
	}

	return {
		slideToggle: slideToggleAction,
		divToggle: hideAndShowAnotherDiv,
		classToggle: classToggleAction,
		classSwitch: classSwitchAction,
		isVisible: visibilityCheck,
		remClass: removeClass,
		remove,
		append,
		prepend,
		clone,
		getNthAncestor,
		serializeForm,
		serializeArray,
		after,
		before,
		insertAfter,
		debounce
	}
}

const colorMapping = {
	"null"						: "transparent",
	"dummy"						: "transparent",
	"statuscol_nocolor"			: "transparent",
	"statuscol_lightgreen" 		: "#98ca3c",
	"statuscol_yellowishorange" : "#fbc11e",
	"statuscol_darkgreen" 		: "#4fd3e5",
	"statuscol_red" 			: "#f56b62",
	"statuscol_closed"			: "#f56b62",
	"statuscol_blue" 			: "#08aeea",
	"statuscol_darkshadegreen" 	: "#2cc8ba",
	"statuscol_navyblue" 		: "#67a0ff",
	"statuscol_purple" 			: "#a593ff",
	"statuscol_darkblue" 		: "#ff7bd7",
	"statuscol_darknavyblue" 	: "#558dca",
	"statuscol_green" 			: "#74cb80",
	"statuscol_open" 			: "#74cb80",
	"status-open-bg" 			: "#74cb80",
	"statuscol_lightorange" 	: "#e6cb4c",
	"statuscol_darkbrown" 		: "#b99897",
	"statuscol_orange" 			: "#f6a96d",
	"statuscol_lightbrown" 		: "#c5a070",
	"statuscol_lightgrey" 		: "#49e6cf",
	"statuscol_materialgreen" 	: "#8cbabb",
	"statuscol_darkgray" 		: "#a7bcee",
	"statuscol_skyblue" 		: "#db9aca",
	"statuscol_lightslategrey" 	: "#a9b2c0",

	"kan_st_col0" 	: "transparent",
	"kan_st_col1" 	: "#c5a070",
	"kan_st_col2" 	: "#a7bcee",
	"kan_st_col3" 	: "#b99897",
	"kan_st_col4" 	: "#08aeea",
	"kan_st_col5" 	: "#98ca3c",
	"kan_st_col6" 	: "#a9b2c0",
	"kan_st_col7" 	: "#db9aca",
	"kan_st_col8" 	: "#e6cb4c",
	"kan_st_col9" 	: "#2cc8ba",
	"kan_st_col10" 	: "#a593ff",
	"kan_st_col11" 	: "#74cb80",
	"kan_st_col12" 	: "#f56b62",
	"kan_st_col13" 	: "#ff7bd7",
	"kan_st_col14" 	: "#67a0ff",
	"kan_st_col15" 	: "#e6cb4c",
	"kan_st_col16" 	: "#8cbabb",
	"kan_st_col17" 	: "#558dca",
	"kan_st_col18" 	: "#f6a96d",
	"kan_st_col19" 	: "#fbc11e",
	"kan_st_col20" 	: "#49e6cf",

	"approvalbgCol" : "#7ace4c",
	"rejectbgCol"	: "#f33155",
	"pendingbgCol"	: "#78909c",
	"draftbgCol"	: "#ff9514"
};

function convertToHexColorTemp(colorValue) {
	if (colorValue == null) {
		return "transparent";
	}
	colorValue = colorValue.trim().replace(/\s+/g, '');
	if (/^#([0-9A-F]{3}){1,2}$/i.test(colorValue)) {
		return colorValue;
	}
	return colorMapping[colorValue] || "transparent";
}

//ignorei18n_ends

Object.assign(window, {
	UI, getDocObj, convertPixelToInches, setFocus, createAndSetAttributes, setDomAttributes,
	createElem, appendChildren, failureMsg, toggleSwitchHide, attentionClick, ShowHideBlock, showHide, ShowHideBlockGeneral,
	ShowHideInline, showHideMultipleDiv, showHideByClass, ShowGenBlock, Hide, dispNone, setShowHide, dispBlock, replaceWithClass,
	setRemoveClass, SwapDivClasses, setAsVisible, changeElementClass, switchHide, setHide, removeHide, Show, ChangeClass,
	ForceShowGenInline, ShowGenInline, loadAjaxTab, ajaxLoading, jqToJs, showAccessDenied, insertAfter, convertToHexColorTemp, KPIAutoFitText
});
